import { useState } from "react";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import CommentsService from "../../services/CommentsService";
import { Icon, Rating } from "@mui/material";
import { FavoriteBorder, Reply } from "@mui/icons-material";
import { showToastError, showToastSuccess } from "utils/toasts";
import placeholder from "images/placeholder-small.png";
import placeholderAvatar from "data/avatars/avatar.jpg";

const Comments = ({
  dados,
  get,
  url = "/posts/tips/comment",
  urlAnswer = "/posts/tips/answer",
  tela = "dica",
  classe = "flex flex-col lg:flex-row mx-4 lg:mx-[16vw] my-10 justify-between",
}: any) => {
  const [comentario, setComentario] = useState("");
  const [resposta, setResposta] = useState("");
  const [respondendoA, setRespondendoA] = useState(null);

  const storedUserData = localStorage.getItem("userData");
  const initialUserData = storedUserData ? JSON.parse(storedUserData) : {};
  const [dadosUser, setDadosUser] = useState(initialUserData);

  const [rating, setRating] = useState(0);

  const [loading, setLoading] = useState(false);

  const enviarComentario = async () => {
    if (comentario == "") {
      // alert("Comentário não pode ser vazio");
      showToastError("Comentário não pode ser vazio");
      return;
    }

    if (rating == 0) {
      showToastError("Por favor, escolha uma avaliação.");
      return;
    }

    if (!dadosUser.id) {
      showToastError(" Vocé precisa estar logado para adicionar um comentário.");
      return;
    }

    let dadosComment: any = {
      user_id: dadosUser.id,
      comment: comentario,
      rating:  rating,
    };
    if (tela == "dica") {
      dadosComment.tip_id = dados.id;
    }

    if (tela == "evento") {
      dadosComment.event_id = dados.id;
    }

    if (tela == "partnerships") {
      dadosComment.partnership_id = dados.id;
    }

    if (tela == "classifieds") {
      dadosComment.classified_id = dados.id;
    }

    setLoading(true);
    await CommentsService.postComentario(dadosComment, url)
      .then((response: any) => {
        showToastSuccess("Comentário respondido com sucesso");
        get();
        //setDicas(response.data);
      })
      .catch((error: any) => {
        showToastError("Erro ao enviar comentário");
        setLoading(false);
      });
  };

  const enviarResposta = async () => {
    if (resposta === "") {
      showToastError("Resposta não pode ser vazia");
      return;
    }

    if (!dadosUser.id) {
      showToastError(" Vocé precisa estar logado para adicionar uma resposta.");
      return;
    }

    let dadosResposta: any = {
      user_id: dadosUser.id,
      answer: resposta,
    };

    if (tela == "dica") {
      dadosResposta.tip_id = dados.id;
      dadosResposta.comment_tip_id = respondendoA;
    }

    if (tela == "evento") {
      dadosResposta.event_id = dados.id;
      dadosResposta.comment_event_id = respondendoA;
    }

    if (tela == "partnerships") {
      dadosResposta.partnership_id = dados.id;
      dadosResposta.comment_partnership_id = respondendoA;
    }

    if (tela == "classifieds") {
      dadosResposta.classified_id = dados.id;
      dadosResposta.comment_classified_id = respondendoA;
    }

    setLoading(true);
    await CommentsService.postComentarioResposta(dadosResposta, urlAnswer)
      .then((response: any) => {
        showToastSuccess("Resposta enviada com sucesso");
        setResposta("");
        setRespondendoA(null);
        get();
      })
      .catch((error: any) => {
        showToastError("Erro ao enviar resposta");
        setLoading(false);
        console.error(error);
      });
  };
  return (
    <div className={classe}>
      <div className="w-100">
        <div className="flex justify-start">{/* ... (código anterior) */}</div>
        <div className="w-full mt-10">
          <h1 className="font-semibold">Comentários</h1>

          <div className="mt-1">
            <Rating
              name="simple-controlled"
              value={rating}
              onChange={(event, newValue) => {
                setRating(newValue);
              }}
            />
          </div>

          <textarea
            placeholder="Descreva aqui a sua experiência"
            className="mt-5 w-full rounded-xl dark:bg-gray-600 overflow-hidden resize-none border-gray-200 dark:border-gray-400"
            onChange={(e) => setComentario(e.target.value)}
          ></textarea>
          <div className="flex gap-10">
            <button
              onClick={() => enviarComentario()}
              className="rounded-full h-12 px-8 mt-5 bg-primary-800 dark:hover:bg-gray-300 text-white hover:bg-primary-500 shadow-sm"
              disabled={loading}
            >
              Enviar Comentário
            </button>
            {/*<button
              className="rounded-full dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 h-12 px-8 mt-5 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm"
              onClick={() => {
                setComentario("");
                setResposta("");
                setRespondendoA(null);
              }}
            >
              Cancelar Comentário
            </button> */}
          </div>

          {dados.comments?.map((comment: any) => {
            const urlBase: any =
              process.env.REACT_APP_BACKEND_API_URL + "/storage/users";
            const ImageUrl: any = urlBase + `/${comment.user.avatar_path}`;

            const ImageUrlPostUser: any =
              urlBase + `/${dados.post.user.avatar_path}`;

            return (
              <div
                key={comment.id}
                className="flex flex-col lg:flex-row w-full mt-20 lg:mt-20"
              >
                <img
                  alt=""
                  className="rounded-full h-10 w-12 object-cover mb-4 lg:mb-0 lg:mr-4"
                  src={ImageUrl}
                  onError={(e) => (e.currentTarget.src = placeholderAvatar)}
                ></img>
                <div className="w-full">
                  <div className="border rounded-xl dark:border-gray-400">
                    <div className="p-1">
                      <div className="flex justify-between items-center">
                        <div>
                          <span className="text-primary-600 font-semibold ms-1">
                            {comment.user.display_name}
                          </span>
                          <span className="text-gray-400">
                            {" "}
                            .{" "}
                            {format(
                              parseISO(comment.created_at),
                              "d 'de' MMMM, yyyy",
                              { locale: ptBR }
                            )}
                          </span>
                        </div>
                        <div className="flex justify-center items-center hover:bg-primary-300 hover:text-white rounded-full w-8 h-8 cursor-pointer">
                          <span className="text-gray-400 mt-[-10px] hover:text-gray-200">
                            ...
                          </span>
                        </div>
                      </div>

                      {
                        (comment.rating && comment.rating != 0) && (
                          <Rating
                            name="read-only"
                            value={comment.rating}
                            readOnly
                          />
                        )
                      }

                      <div className="ms-1 mt-1">
                        <p className="text-justify min-h-[3rem] lg:min-h-[5rem]">
                          {comment.comment}
                        </p>
                      </div>

                      {comment.answer !== null && (
                        <>
                        {/* <h1 className="font-semibold">Resposta</h1> */}
                        <div
                          key={comment.id}
                          className="flex flex-col lg:flex-row w-full mt-4"
                        >
                          <img
                            alt=""
                            className="rounded-full h-10 w-12 object-cover mb-4 lg:mb-0 lg:mr-4"
                            src={ImageUrlPostUser}
                            onError={(e) => (e.currentTarget.src = placeholderAvatar)}
                          ></img>
                          <div className="w-full">
                            <div className="border rounded-xl dark:border-gray-400">
                              <div className="p-1">
                                <div className="flex justify-between items-center">
                                  <div>
                                    <span className="text-primary-600 font-semibold">
                                      {dados.post.user.display_name}
                                    </span>
                                    <span className="text-gray-400">
                                      {" "}
                                      .{" "}
                                      {format(
                                        parseISO(comment.created_at),
                                        "d 'de' MMMM, yyyy",
                                        { locale: ptBR }
                                      )}
                                    </span>
                                  </div>
                                  <div className="flex justify-center items-center hover:bg-primary-300 hover:text-white rounded-full w-8 h-8 cursor-pointer">
                                    <span className="text-gray-400 mt-[-10px] hover:text-gray-200">
                                      ...
                                    </span>
                                  </div>
                                </div>

                                <div>
                                  <p className="text-justify min-h-[3rem] lg:min-h-[5rem]">
                                    {comment.answer.answer}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div></>
                      )}

                      {comment.answer === null && (
                        <div className="flex gap-x-10">
                          {/* <button className="rounded-full h-12 px-8 mt-5 dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm">
                            <Icon
                              component={FavoriteBorder}
                              fontSize="small"
                              className="mr-2"
                            />
                            {(Math.random() * 100).toFixed()}
                          </button> */}
                          <button
                            onClick={() => setRespondendoA(comment.id)}
                            className="rounded-full h-12 px-8 mt-5 dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm"
                          >
                            <Icon
                              component={Reply}
                              fontSize="small"
                              className="mr-2"
                            />
                            Responda
                          </button>
                        </div>
                      )}

                      {respondendoA === comment.id && (
                        <>
                          <textarea
                            placeholder="Responda"
                            className="mt-5 w-full rounded-xl dark:bg-gray-600 overflow-hidden resize-none border-gray-200 dark:border-gray-400"
                            value={resposta}
                            onChange={(e) => setResposta(e.target.value)}
                          ></textarea>
                          <div className="flex gap-10">
                            <button
                              onClick={() => enviarResposta()}
                              className="rounded-full h-12 px-8 mt-5 bg-primary-800 dark:hover:bg-gray-300 text-white hover:bg-primary-500 shadow-sm"
                              disabled={loading}
                            >
                              Enviar Resposta
                            </button>
                            <button
                              onClick={() => {
                                setResposta("");
                                setRespondendoA(null);
                              }}
                              className="rounded-full dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 h-12 px-8 mt-5 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm"
                            >
                              Cancelar Resposta
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Comments;
